import { ReferralCouponFragment } from 'drycut-graphql';
import { Para, Stack } from 'ui-components';

type Props = {
  coupon: ReferralCouponFragment;
};

export default function RedemptionSteps({ coupon }: Props): React.ReactElement {
  return (
    <Stack gap={4} className="text-left text-pretty my-3">
      <Para className="text-center lg:text-start font-aribaubold">
        So einfach sparst Du 13 CHF:
      </Para>

      <Stack as="ol" gap={4} className="list-inside list-decimal">
        <Para as="li">
          Unten auf „Cut Now“ klicken und direkt den nächsten verfügbaren Slot in Deinem bevorzugten
          Salon wählen. Der Code wird dabei automatisch eingelöst.
        </Para>

        <Para as="li">
          Alternativ kannst Du normal im Salon oder über die Website buchen und Deinen persönlichen
          Gutscheincode eingeben und damit 13 CHF auf den ersten Cut sparen.
        </Para>

        <Para as="li">
          Sobald Du den Code eingelöst hast, schicken wir {coupon.customer?.name} ebenfalls einen
          Gutschein für CHF 13.
        </Para>
      </Stack>
    </Stack>
  );
}
